module.exports = __webpack_public_path__ + "img/farming-hover.5517b055.svg";